import { render, staticRenderFns } from "./BuyReportComponent.vue?vue&type=template&id=70f16f86&"
import script from "./BuyReportComponent.vue?vue&type=script&lang=js&"
export * from "./BuyReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports